/** Compatibility for contours whose menu seed predates the new translations page.
 * Only replace an entry already granted by the server. Never invent a grant.
 */
export function withTranslationsEntry<T extends { items: { url: string; app: string; internal: boolean }[] }>(groups: T[]): T[] {
  if (groups.some((g) => g.items.some((i) => i.internal && i.url === '/translations-v2'))) return groups;
  return groups.map((g) => ({ ...g, items: g.items.map((i) => i.url === '/legacy/translations'
    ? { ...i, url: '/translations-v2', app: 'portal-v2', internal: true } : i) }));
}
